
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/[page]",
      function () {
        return require("private-next-pages/[event]/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/[page]"])
      });
    }
  